import calendarIcon from '../../assets/icons/calender.svg'

const CalendarIcon = () => (
    <img src={calendarIcon} alt="Calendar" />
  );
  
  export default CalendarIcon;